import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import action from './action';
import * as getters from './getters';
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    state,
    mutations,
    getters,
    action,
    strict: debug,
    plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js